import { TRANSLATIONS_APP_NAME, TranslationsContext } from '@telia-common-components/shared';
import React from 'react';
import { Separator } from 'telia-front-react';
export const Go3AppPacketInclusion = (props) => {
    const { translateOrEmpty } = React.useContext(TranslationsContext);
    const text = translateOrEmpty(TRANSLATIONS_APP_NAME, `go3App.includedInPacket.${props.productCode}`);
    if (!text) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        text,
        React.createElement(Separator, { spacing: "xxsmall", color: "invisible" })));
};
